module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10275.b9609bb5.jpg";